// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","adminLink":"Footer_adminLink__l+Ji2"};